import { type ModalProps } from '@/ui/Modal/modal.component';
import { ErrorModal } from '@/ui';

export type ErrorModalProps = Omit<ModalProps, 'onClose'> & {
  title?: string;
  description?: string;
  onClose?: ModalProps['onClose'];
};

export const PaymentErrorModal = ({
  title,
  description = "We couldn't process your payment. Please check your card details and try again.\nStill having trouble? Contact our support team.",

  onClose = () => {},
  ...rest
}: ErrorModalProps) => {
  return (
    <ErrorModal
      {...rest}
      title={title ? title : "Oops! Payment didn't go through"}
      description={description}
      actionLabel="Try again"
      onClose={onClose}
    />
  );
};
